import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ShippingAddress, UserServiceModal } from 'src/app/modals/userservice.modal';
import { State } from 'src/app/modals/state.modal';
import { RestApiService } from '../../services/restapi.service';
import { UserService } from '../../services/user.service';
import { DefaultCountry } from 'src/app/constant';

@Component({
  selector: 'app-shipping-address-dialog',
  templateUrl: './shipping-address-dialog.component.html',
  styleUrls: ['./shipping-address-dialog.component.scss']
})
export class ShippingAddressDialogComponent implements OnInit {
  IsDialogMax: boolean = false;
  hostHeight: any;
  hostWidth: any;
  differentAddressShow: boolean = false;
  public newShipping: ShippingAddress = {} as ShippingAddress;
  newAddressSelected: boolean = false;
  defaultAddress: any = {};
  userService: UserServiceModal;
  public allowedCountries: any = [];
  states: Array<State> = [];
  constructor(
    public dialogRef: MatDialogRef<any>,
    public matDialogRef: MatDialogRef<ShippingAddressDialogComponent>,
    public user: UserService,
    public apiService: RestApiService,
    private cdr: ChangeDetectorRef
  ) {
    this.defaultAddress = this.user.userServiceModal.shippingAddress;
    this.userService = this.user.userServiceModal;
  }

  ngOnInit(): void {
    // Initialize CountryCode to DefaultCountry if not set
    if (!this.newShipping.CountryCode) {
      const existingCountry = this.defaultAddress?.CountryCode || this.userService?.shippingAddress?.CountryCode;
      this.newShipping.CountryCode = existingCountry ? existingCountry.toUpperCase() : DefaultCountry;
    } else {
      this.newShipping.CountryCode = this.newShipping.CountryCode.toUpperCase();
    }

    this.apiService.getActiveCountries().subscribe(data => {
      // Handle both response formats: { Status: 0, Data: [...] } or just [...]
      this.allowedCountries = data?.Data || (Array.isArray(data) ? data : []);
      
      // Normalize all country codes to uppercase for consistency
      this.allowedCountries = this.allowedCountries.map(country => ({
        ...country,
        CountryCode: country.CountryCode ? country.CountryCode.toUpperCase() : country.CountryCode
      }));
      
      // Ensure selected country code matches the format
      if (this.newShipping.CountryCode) {
        this.newShipping.CountryCode = this.newShipping.CountryCode.toUpperCase();
      }
      
      this.cdr.detectChanges();
      this.getCountryState(this.newShipping.CountryCode || DefaultCountry);
    }, (error) => {
      this.newShipping.CountryCode = (this.newShipping.CountryCode || DefaultCountry).toUpperCase();
      this.allowedCountries = [];
      this.cdr.detectChanges();
    });

  }
  getCountryState(country?: string) {
    if (!country) {
      country = this.newShipping.CountryCode || DefaultCountry;
    }
    country = country.toUpperCase();
    
    this.apiService.getStates(country || DefaultCountry).subscribe((result) => {
      const statesData = result?.Data || result || [];
      sessionStorage.setItem((country || DefaultCountry) + 'State', JSON.stringify(statesData));
      this.states = statesData;
      
      // Match existing region if available
      if (this.newShipping.Region && this.states.length > 0) {
        const matchingState = this.states.find(s => 
          s.StateCode?.toUpperCase() === this.newShipping.Region?.toUpperCase()
        );
        if (matchingState) {
          this.newShipping.Region = matchingState.StateCode;
        }
      }
      
      this.cdr.detectChanges();
    }, (error) => {
      this.states = [];
      this.cdr.detectChanges();
    });
  }
  onClickDifferentAddress(checked) {
    this.differentAddressShow = checked;
    this.newAddressSelected = checked;
    
    if (checked && this.defaultAddress) {
      const existingCountry = this.defaultAddress.CountryCode || this.userService.shippingAddress?.CountryCode || DefaultCountry;
      
      this.newShipping = {
        FirstName: this.defaultAddress.FirstName || this.userService.shippingAddress?.FirstName || '',
        LastName: this.defaultAddress.LastName || this.userService.shippingAddress?.LastName || '',
        Street1: this.defaultAddress.Street1 || this.userService.shippingAddress?.Street1 || '',
        Street2: this.defaultAddress.Street2 || this.userService.shippingAddress?.Street2 || '',
        City: this.defaultAddress.City || this.userService.shippingAddress?.City || '',
        Region: this.defaultAddress.Region || this.userService.shippingAddress?.Region || '',
        PostalCode: this.defaultAddress.PostalCode || this.userService.shippingAddress?.PostalCode || '',
        CountryCode: existingCountry.toUpperCase(),
        Phone: this.defaultAddress.Phone || this.userService.shippingAddress?.Phone || ''
      } as ShippingAddress;
      
      this.cdr.detectChanges();
      this.getCountryState(this.newShipping.CountryCode);
    } else if (!checked) {
      this.newShipping = {} as ShippingAddress;
      this.newShipping.CountryCode = DefaultCountry;
      this.cdr.detectChanges();
    }
  }
  saveNewAddress() {
    this.matDialogRef.close({ address: this.newShipping, isReplacement: true });
  }
  close() {
    this.matDialogRef.close({ address: this.newShipping, isReplacement: false });
  }

}
